/* Organizer Website — real-data profile stats. Computed server-side; the
   organizer only toggles visibility per stat. */
import { useTranslation } from "react-i18next";

const STAT_DEFS = [
  { key: "auctions", toggle: "show_auctions", labelKey: "web.statAuctions" },
  { key: "horses_sold", toggle: "show_horses_sold", labelKey: "web.statHorsesSold" },
  { key: "countries", toggle: "show_countries", labelKey: "web.statCountries" },
  { key: "years_active", toggle: "show_years", labelKey: "web.statYears" },
];

export const WebsiteStats = ({ stats, config }) => {
  const { t } = useTranslation();
  if (!stats || config?.enabled === false) return null;
  const visible = STAT_DEFS.filter((d) => config?.[d.toggle] !== false && stats[d.key] > 0);
  if (!visible.length) return null;
  return (
    <dl className="grid grid-cols-2 gap-4" data-testid="website-stats">
      {visible.map((d) => (
        <div key={d.key} className="rounded-2xl border border-black/5 bg-[#FAFAF8] p-6 flex flex-col gap-1" data-testid={`website-stat-${d.key}`}>
          <dd className="text-4xl font-light tabular-nums text-[#0A0A0A] brand-heading">{stats[d.key]}</dd>
          <dt className="text-xs font-medium text-[#737373]">{t(d.labelKey)}</dt>
        </div>
      ))}
    </dl>
  );
};
